import styled from 'styled-components';
import { COLOR, FONT_SIZE, SPACING } from '../../../constants/theme';
import { LineItem } from '../../../components/common/DocumentCard';

export const ServiceLineItem = styled(LineItem)`
  padding-top: 0;
  border-top: none;
  border-bottom: none;
`;

export const ClinicianName = styled.div`
  margin-top: ${SPACING.sm};
  font-size: ${FONT_SIZE.cardTitle};
  font-weight: 700;
  line-height: 1.35;
  color: ${COLOR.navy};
`;

export const ClinicianSpeciality = styled.div`
  margin-top: 1px;
  font-size: ${FONT_SIZE.body};
  font-weight: 500;
  color: ${COLOR.text};
`;

export const ClinicianRow = styled.div`
  margin-bottom: ${SPACING.lg};
`;

export const AttestationRow = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 11px;
  margin: 0;
  cursor: pointer;

  .ant-checkbox-wrapper {
    flex: none;
    margin-top: 2px;
  }

  .ant-checkbox-inner {
    width: 19px;
    height: 19px;
  }
`;

export const AttestationText = styled.p`
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.45;
  color: ${COLOR.text};
`;
